import StateType, { InvoiceType } from './state.type';

export default {
  toggleLoading(state: StateType, isLoading: boolean): void {
    state.loading = isLoading;
  },
  setInvoices(state: StateType, invoices: InvoiceType[]): void {
    state.invoices = invoices;
  },
  setTotal(state: StateType, total: number): void {
    state.total = total;
  },
};
